"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.delete.tooltip': '删除对话',
    'conversations.delete.confirm': '您确定要删除 "{title}" 吗？此操作无法撤销。',
};
